import React from 'react';

import Modal from '../../../../components/Modal';
import { useHideCobuyer } from '../../../../hooks';
import { DealWithFarthestState } from '../../utils';
import WelcomeModalContent from './WelcomeModalContent';

interface Props {
  deal: DealWithFarthestState;
  isOpen: boolean;
  onClose: () => void;
  onCloseComplete?: () => void;
}

const WelcomeModal = ({ deal, isOpen, onClose, onCloseComplete }: Props) => {
  const isCobuyer = deal?.isCobuyer;
  const hideCobuyer = useHideCobuyer(deal);

  const title = `Welcome to your ${isCobuyer && !hideCobuyer ? 'Co-Buyer ' : ''}Dashboard`;

  return (
    <Modal title={title} isOpen={isOpen} onClose={onClose} onCloseComplete={onCloseComplete}>
      <WelcomeModalContent deal={deal} onClose={onClose} />
    </Modal>
  );
};

export default WelcomeModal;
